import { render, staticRenderFns } from "./store-hotsale.vue?vue&type=template&id=5cf2ff64&scoped=true"
import script from "./store-hotsale.vue?vue&type=script&lang=js"
export * from "./store-hotsale.vue?vue&type=script&lang=js"
import style0 from "./store-hotsale.vue?vue&type=style&index=0&id=5cf2ff64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf2ff64",
  null
  
)

export default component.exports